<template>
  <div class="betalok-quiz">
    <div class="betalok-quiz__top-banner">
      <img
        :src="`
      https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/banner.jpg`"
      />
      <div class="content">
        <div class="betalok-quiz__top-banner-text">
          <div class="betalok-quiz__top-banner-title">
            Утреннее повышение АД <br />и безопасная стратегия,
            <br />направленная на его <br />снижение
          </div>
          <div class="betalok-quiz__top-banner-tag">викторина</div>
        </div>
      </div>
    </div>
    <Breadcrumbs
      :pages="[
        { name: 'Препараты АЗ', link: { name: 'Medications' } },
        { name: 'Беталок ЗОК 25, 50, 100 мг', link: { name: 'BetalockLand' } },
        {
          name: 'Утреннее повышение АД и безопасная стратегия, направленная на его снижение.',
        },
      ]"
      :color="'#3C1053'"
    />
    <div class="content">
      <div class="betalok-quiz__body">
        <div class="betalok-quiz__content">
          <div class="betalok-quiz__title mb-13 d-none d-xl-block">
            Утреннее повышение АД и безопасная стратегия, направленная на его
            снижение
          </div>
          <img
            class="mb-8 d-xl-none"
            :src="`
      https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/banner_mob.jpg`"
          />
          <div class="betalok-quiz__subtitle mb-4" id="chapter1">
            Биологические ритмы артериального давления: в чем особенность
            гипертензии у пациентов с ишемической болезнью сердца?
          </div>
          <div class="betalok-quiz__text mb-4">
            Известный факт, что на протяжении суток как у здоровых людей, так и
            у пациентов с артериальной гипертензией (АГ) отмечается значительное
            колебание уровня артериального давления (АД)<sup>1</sup>. Происходит
            это в результате нейрогуморальной дисрегуляции, в том числе и прежде
            всего в связи с физиологической активацией симпатоадреналовой и
            ренин-ангиотензин-альдостероновой систем (РААС), увеличением
            симпатической и снижением парасимпатической активности<sup>1</sup>.
          </div>
          <div class="betalok-quiz__text mb-4">
            В то же время, утренние часы — это единственный период в течение
            суток, когда также определяются:
          </div>
          <ul class="betalok-quiz__list mb-4">
            <li><span>повышение агрегации тромбоцитов;</span></li>
            <li><span>гиперкоагуляция;</span></li>
            <li><span>снижение фибринолитической активности. </span></li>
          </ul>
          <div class="betalok-quiz__text mb-4">
            При этом для гипертоников зачастую характерен более выраженный по
            длительности и величине прирост уровня АД, который происходит с
            большей скоростью<sup>1</sup>.
          </div>
          <div
            class="betalok-quiz__question"
            data-title="Какой период в утренние часы считается периодом максимального подъема давления?"
          >
            <picture>
              <source
                :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q1_mob.jpg
                `"
                media="(max-width: 767px)"
              />
              <source
                :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q1.jpg
                `"
              />
              <img
                class="mb-5"
                :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q1.jpg
                `"
              />
            </picture>
            <div class="betalok-quiz__variants mb-13">
              <label
                for="q1v1"
                class="betalok-quiz__variant"
                :class="{ 'betalok-quiz__variant_disabled': answers[0] }"
              >
                <input
                  id="q1v1"
                  v-model="answers[0]"
                  type="radio"
                  value="С 4 до 8"
                  @change="answerQuestion($event)"
                />
                <div class="betalok-quiz__variant-letter-container">
                  <div class="betalok-quiz__variant-letter">а</div>
                </div>
                <div class="betalok-quiz__variant-label">С 4 до 8</div>
              </label>
              <label
                for="q1v2"
                class="betalok-quiz__variant"
                :class="{ 'betalok-quiz__variant_disabled': answers[0] }"
              >
                <input
                  id="q1v2"
                  v-model="answers[0]"
                  type="radio"
                  value="С 6 до 12"
                  @change="answerQuestion($event)"
                />
                <div class="betalok-quiz__variant-letter-container">
                  <div class="betalok-quiz__variant-letter">б</div>
                </div>
                <div class="betalok-quiz__variant-label">С 6 до 12</div>
              </label>
              <label
                class="betalok-quiz__variant"
                :class="{ 'betalok-quiz__variant_current': answers[0] }"
              >
                <input
                  id="q1v2"
                  v-model="answers[0]"
                  type="radio"
                  value="С 4 до 10"
                  @change="answerQuestion($event)"
                />
                <div class="betalok-quiz__variant-letter-container">
                  <div class="betalok-quiz__variant-letter">в</div>
                </div>
                <div class="betalok-quiz__variant-label">С 4 до 10</div>
              </label>
            </div>
            <div class="betalok-quiz__answer mb-13" v-if="answers[0]">
              <div class="betalok-quiz__answer-title">
                <img
                  :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/clock.png
                `"
                />
                Время узнать ответ!
              </div>
              <div class="betalok-quiz__answer-subtitle">
                Периодом наивысшего подъема давления считается промежуток с 4 до
                10 утра.
              </div>
              <div class="betalok-quiz__answer-description">
                В это время симпатоадреналовая система, регулирующая почти все
                физиологические функции организма, входит в режим наибольшей
                суточной активности.<sup>1</sup>
              </div>
            </div>
          </div>
          <div class="betalok-quiz__subtitle mb-4" id="chapter2">
            В чем опасность «утренних скачков» давления для кардио-пациента?
          </div>
          <div class="betalok-quiz__text mb-4">
            Такая физиологическая особенность может представлять определенную
            опасность для пациентов с сопутствующими СС-заболеваниями. Дело в
            том, что ранние утренние часы ассоциируются с повышенным риском
            сердечно-сосудистых, цереброваскулярных осложнений, а также
            внезапной смерти<sup>1</sup>.
          </div>
          <div class="betalok-quiz__text mb-4">
            Так, во Фремингемском эпидемиологическом исследовании показано, что
            время максимального риска внезапной смерти приходится на утренние
            часы (с 7 до 9 ч), минимального риска — на период с 9 до 13 ч.
          </div>
          <picture>
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/1_mob.jpg
                `"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/1.jpg
                `"
            />
            <img
              class="mb-4"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/1.jpg
                `"
            />
          </picture>
          <div class="betalok-quiz__text mb-4">
            Риск внезапной смерти в утренние часы в среднем на 70% выше, чем в
            остальные периоды суток<sup>1,2</sup>.
            <b
              >Именно с утренним повышением АД во многом связан более чем
              двукратный риск возникновения инфаркта миокарда, нарушений ритма
              сердца и внезапной смерти больных с сердечно-сосудистыми
              заболеваниями в первые часы после пробуждения и подъема
              с постели<sup>1,3,4</sup>.</b
            >
          </div>
          <div class="betalok-quiz__subtitle mb-4" id="chapter3">
            Пациент с ИБС: как достичь контроля АД и ЧСС без скачков в утренние
            часы?
          </div>
          <div class="betalok-quiz__text mb-4">
            Согласно клиническим рекомендациям, при стабильной стенокардии I-II
            ФК и ЧСС &gt;60 уд./мин в качестве препарата 1-й линии рекомендуется
            назначить бета-адреноблокаторы (БАБ), а при стабильной стенокардии
            III-IV ФК, в отсутствие противопоказаний рекомендуется сразу
            назначить комбинацию БАБ с ДГП-БКК для достижения ФК I<sup>5</sup>.
            Встает логичный вопрос: какому препарату стоит отдать предпочтение?.
          </div>
          <div
            class="betalok-quiz__question"
            data-title="Какой β-адреноблокатор наиболее эффективен в контроле АД в утренние часы?"
          >
            <picture>
              <source
                :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q2_mob.jpg
                `"
                media="(max-width: 767px)"
              />
              <source
                :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q2.jpg
                `"
              />
              <img
                class="mb-5"
                :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/q2.jpg
                `"
              />
            </picture>
            <div class="betalok-quiz__variants mb-13">
              <label
                for="q2v1"
                class="betalok-quiz__variant"
                :class="{ 'betalok-quiz__variant_disabled': answers[1] }"
              >
                <input
                  id="q2v1"
                  v-model="answers[1]"
                  type="radio"
                  value="Бисопролол"
                  @change="answerQuestion($event)"
                />
                <div class="betalok-quiz__variant-letter-container">
                  <div class="betalok-quiz__variant-letter">а</div>
                </div>
                <div class="betalok-quiz__variant-label">Бисопролол</div>
              </label>
              <label
                for="q2v2"
                class="betalok-quiz__variant"
                :class="{ 'betalok-quiz__variant_current': answers[1] }"
              >
                <input
                  id="q2v2"
                  v-model="answers[1]"
                  type="radio"
                  value="Метопролола сукцинат CR/XL"
                  @change="answerQuestion($event)"
                />
                <div class="betalok-quiz__variant-letter-container">
                  <div class="betalok-quiz__variant-letter">б</div>
                </div>
                <div class="betalok-quiz__variant-label">
                  Метопролола сукцинат CR/XL
                </div>
              </label>
            </div>
            <div class="betalok-quiz__answer mb-13" v-if="answers[1]">
              <div class="betalok-quiz__answer-title">
                <img
                  :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/clock.png
                `"
                />
                Время узнать ответ!
              </div>
              <div class="betalok-quiz__answer-subtitle">
                Препарат метопролола сукцинат — Беталок<sup>®</sup> ЗОК!
              </div>
            </div>
          </div>
          <div class="betalok-quiz__text mb-4">
            Это селективный бета-блокатор с замедленным контролируемым
            высвобождением<sup>6,7</sup>.
          </div>
          <div class="betalok-quiz__text mb-4">
            Исследование с применением моделирования данных 266 пациентов
            показало превосходство препарата Беталок<sup>®</sup> ЗОК в контроле
            АД в утренние часы<sup>8</sup>.
          </div>
          <picture>
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/2_mob.jpg
                `"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/2.jpg
                `"
            />
            <img
              class="mb-4"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/2.jpg
                `"
            />
          </picture>
          <div class="betalok-quiz__text mb-4">
            Особое строение Беталок<sup>®</sup> ЗОК обеспечивает постоянство
            концентрации действующего вещества и отсутствие явных пиковых
            концентраций в плазме крови, что позволяет избежать негативного
            влияния, вызванного спадами и подъемами АД<sup>6,7</sup>.<br />В
            клинических исследованиях также было доказано превосходство
            препарата Беталок<sup>®</sup> ЗОК (метопролол сукцината) в сравнении
            с метопролол тартратом<sup>9,10</sup>.
          </div>
          <picture>
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/3_mob.jpg
                `"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/3.jpg
                `"
            />
            <img
              class="mb-13"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/3.jpg
                `"
            />
          </picture>
          <div class="betalok-quiz__title mb-4" style="color: #3e1876">
            Беталок<sup>®</sup> ЗОК —
          </div>
          <div class="betalok-quiz__subtitle mb-4">
            бета-блокатор в особой* форме для контроля более 24 часов* АД и ЧСС
            с благоприятным профилем безопасности<sup>6,7,8,10,13</sup>
          </div>
          <picture>
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/4_mob.jpg
                `"
              media="(max-width: 767px)"
            />
            <source
              :srcset="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/4.jpg
                `"
            />
            <img
              class="mb-13"
              :src="`
                https://storage.yandexcloud.net/${$root.backetName}/media/content/public/assets/img/betalock-landing/quiz/4.jpg
                `"
            />
          </picture>
          <div class="betalok-quiz__text mb-4">
            АГ — артериальная гипертензия, АД — артериальное давление, РААС —
            ренин-ангиотензин-альдостероновая система, СС — сердечно-сосудистый,
            ИБС — ишемическая болезнь сердца, ЧСС — частота сердечных
            сокращений, ФК — функциональный класс, БАБ — бета-адреноблокаторы,
            ДГП-БКК — дигидропиридиновые блокаторы «медленных» кальциевых
            каналов.
          </div>
          <div class="betalok-quiz__text mb-4">
            # Под особой формой подразумевается таблетка метопролола сукцината в
            форме CR/XL, которая состоит из спрессованных сферических гранул,
            содержащих активное ЛС и покрытых этилцеллюлозной полимерной
            мембраной, контролирующей высвобождение лекарства из гранул
            (технология CR/XL ZOK — Controlled Release/Extended Release —
            контролируемое высвобождение ЛС/длительное высвобождение ЛС,
            Zero–Order–Kinetics — кинетика нулевого порядка).
          </div>
          <div class="betalok-quiz__text">
            * Указание в инструкции по медицинскому применению ЛП на устойчивый
            клинический эффект более 24 часов.
          </div>
        </div>
        <div class="betalok-quiz__aside">
          <div class="betalok-quiz__aside-title">Содержание:</div>
          <a href="#chapter1" class="betalok-quiz__aside-item">
            Биологические ритмы артериального давления. Какой период в утренние
            часы считается периодом максимального подъема давления?
          </a>
          <a href="#chapter2" class="betalok-quiz__aside-item">
            В чем опасность «утренних скачков» давления для кардио-пациента?
          </a>
          <a href="#chapter3" class="betalok-quiz__aside-item">
            Пациент с ИБС: как достичь контроля АД и ЧСС без скачков в утренние
            часы?
          </a>
        </div>
      </div>
      <div class="betalok-quiz__sources">
        <div class="betalok-quiz__sources-title">Список литературы</div>
        <ol class="betalok-quiz__sources-list">
          <li>
            Остроумова О. Д., Смолярчук Е. А., Резникова К. У. Утренние подъемы
            артериального давления: клиническое значение, методики расчета,
            возможности коррекции препаратом Лодоз // Лечебное дело. 2011. №3.
          </li>
          <li>
            Willich S.N., Levy D., Rocco M.B. et al. Circadian variation in the
            incidence of sudden cardiac death in the Framingham Heart Study
            population // Am. J. Cardiol. 1987. V. 60. P. 801–806.
          </li>
          <li>
            Trenkwalder P., Dobrindt R., Plaschke M., Lydtin H. Usefulness of
            simultaneous ambulato ry electrocardiophic and blood pressure moni
            toring in detecting myocardial ischemia in patients >70 years of age
            with systemic hyperten sion // Am. J. Cardiol. 1993. V. 72. P.
            927–931.
          </li>
          <li>
            Willich S.N., Goldberg R.J., Maclure M. et al. Increased onset of
            sudden cardiac death in the first three hours after awakening // Am.
            J. Cardiol. 1992. V. 70. P. 65–68.
          </li>
          <li>
            Стабильная ишемическая болезнь сердца. Клинические рекомендации
            2024. Российский кардиологический журнал. 2024;29(9):6110.
          </li>
          <li>
            Общая характеристика лекарственного препарата Беталок<sup>®</sup>
            ЗОК (таблетки с пролонгированным высвобождением, покрытые оболочкой,
            25 мг, 50 мг, 100 мг). Регистрационное удостоверение
            ЛП-№(002842)-(РГ-RU) от 24.07.2023
            <a
              href="https://astrazeneca.ru/astrazeneca_in_russia/preparations.html"
              target="_blank"
              >https://astrazeneca.ru/astrazeneca_in_russia/preparations.html</a
            >
          </li>
          <li>Sanberg A. et al, Clin Pharmacol 1990; 30: S2-S16.</li>
          <li>
            Jansson SO, Malm AE, Lundström T. Drugs in R&D. 2014;14(4):325-332.
          </li>
          <li>
            Sandberg A et al. Pharmacokinetic and pharmacodynamic properties of
            a new controlled-release formulation of metoprolol: a comparison
            with conventional tablets. Eur J Clin Pharmacol. 1988;33(Suppl.):
            S9-14.
          </li>
          <li>
            Бубнова М.Г. Место В-адреноблокаторов в лечении сердечно-сосудистых
            заболеваний с позиции современных рекомендаций: в фокусе метопролола
            сукцинат CR/XL. CardioСоматика. 2022;13 (1).
          </li>
          <li>
            Данные сайта Все Аптеки [Электронный ресурс], 20.03.2025 URL:
            <a href="http://vseapteki.ru" target="_blank"
              >http://vseapteki.ru</a
            >
          </li>
          <li>
            Государственный реестр лекарственных средств [Электронный ресурс],
            26-06-2024 URL:
            <a href="http://grls.rosminzdrav.ru" target="_blank"
              >http://grls.rosminzdrav.ru</a
            >
          </li>
          <li>
            Kendall MJ. Journal of Clinical Pharmacy and Therapeutics (1989).
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/pageComponents/Breadcrumbs.vue";
export default {
  name: "BetalokQuiz",
  data: () => ({
    answers: [null, null],
  }),
  components: {
    Breadcrumbs,
  },
  methods: {
    observe() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (typeof ym !== "undefined") {
                ym(91468266, "reachGoal", "betalok", {
                  betalok: {
                    "quiz question show":
                      entry.target.getAttribute("data-title"),
                    ...this.$root.ymFields,
                  },
                });
              }
              console.log();
            }
          });
        },
        {
          threshold: 0.1,
        }
      );

      // находим все секции
      const elements = document.querySelectorAll(".betalok-quiz__question");
      // начинаем за ними наблюдать
      elements.forEach((el) => observer.observe(el));
    },
    answerQuestion(e) {
      ym(91468266, "reachGoal", "betalok", {
        betalok: {
          [e.target
            .closest(".betalok-quiz__question")
            .getAttribute("data-title")]: e.target.value,
          ...this.$root.ymFields,
        },
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.observe();
    });
  },
};
</script>

<style lang="scss" scoped>
.betalok-quiz {
  &__top-banner {
    width: 100%;
    height: 610px;
    position: relative;
    @media screen and (max-width: 1219px) {
      height: auto;
    }

    & img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
      @media screen and (max-width: 1219px) {
        display: none;
      }
    }

    & .content {
      position: absolute;
      z-index: 2;
      height: 100%;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      @media screen and (max-width: 1219px) {
        position: static;
        transform: none;
      }
    }

    &-text {
      padding-top: 110px;
      @media screen and (max-width: 1219px) {
        padding: 48px 0 0;
      }
    }

    &-title {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 55px;
      line-height: 120%;
      color: #3e1876;
      @media screen and (max-width: 1219px) {
        color: #1f1f1f;
        font-size: 42px;
      }
      @media screen and (max-width: 767px) {
        font-size: 26px;
      }
    }

    &-tag {
      margin-top: 16px;
      width: fit-content;
      padding: 8px 36px;
      border-radius: 99px;
      background-color: #3e1876;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #ffffff;
      @media screen and (max-width: 1219px) {
        display: none;
      }
    }
  }

  &__body {
    margin-top: 64px;
    display: grid;
    grid-template-columns: 1fr 280px;
    gap: 32px;
    @media screen and (max-width: 1219px) {
      grid-template-columns: 100%;
    }
  }

  &__aside {
    position: sticky;
    top: 32px;
    height: fit-content;
    @media screen and (max-width: 1219px) {
      display: none;
    }

    &-title {
      margin-bottom: 8px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: #3e1876;
    }

    &-item {
      display: block;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      color: #1f1f1f;

      &:not(:last-child) {
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px dashed #3e1876;
      }
    }
  }

  &__title {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 42px;
    line-height: 48px;
    color: #1f1f1f;
  }

  &__subtitle {
    font-family: "Roboto Slab", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #3e1876;
    @media screen and (max-width: 767px) {
      font-size: 20px;
    }
  }

  &__text {
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;
    color: #3c4242;
    @media screen and (max-width: 767px) {
      font-size: 16px;
    }

    & b {
      font-weight: bold;
    }
  }

  &__list {
    list-style-type: disc;
    margin-left: 1em;

    & li {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      color: #3e1876;

      & span {
        color: #3c4242;
      }
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }

  sup {
    vertical-align: super;
    font-family: inherit;
    font-style: normal;
    font-weight: inherit;
    font-size: 75%;
    line-height: 1;
    color: currentColor;
    white-space: nowrap;
  }

  img {
    max-width: 100%;
  }

  &__variants {
    display: grid;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    gap: 20px;
    @media screen and (max-width: 767px) {
      grid-template-columns: 1fr;
      grid-auto-columns: auto;
      grid-auto-flow: row;
    }
  }

  &__variant {
    border-radius: 99px;
    padding: 8px 12px;
    background-color: #e8e5edb2;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;

    & input {
      display: none;
    }

    &:hover {
      background-color: #cbc0da;
    }

    &_disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    &_current {
      pointer-events: none;
      background-color: #207618;

      & .betalok-quiz__variant {
        &-letter {
          border-color: #207618;
          background-color: #fff;
          color: #207618;
          &-container {
            background-color: #fff;
          }
        }

        &-label {
          color: #fff;
        }
      }
    }

    &-letter {
      width: 38px;
      height: 38px;
      border-radius: 50%;
      border: 1px solid #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 100%;
      color: #ffffff;
      @media screen and (max-width: 1219px) {
        font-size: 18px;
        width: 32px;
        height: 32px;
      }
      @media screen and (max-width: 767px) {
        font-size: 24px;
        width: 38px;
        height: 38px;
      }
      &-container {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        background-color: #3e1876;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        @media screen and (max-width: 1219px) {
          width: 40px;
          height: 40px;
        }
        @media screen and (max-width: 767px) {
          width: 46px;
          height: 46px;
        }
      }
    }

    &-label {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 24px;
      line-height: 100%;
      color: #1f1f1f;
      @media screen and (max-width: 1219px) {
        font-size: 18px;
      }
      @media screen and (max-width: 767px) {
        font-size: 24px;
      }
    }
  }

  &__answer {
    &-title {
      margin-bottom: 16px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 48px;
      color: #830051;

      @media screen and (max-width: 767px) {
        font-size: 30px;
      }

      & img {
        display: inline;
        height: 48px;
        vertical-align: baseline;
        @media screen and (max-width: 767px) {
          height: 24px;
        }
      }
    }

    &-subtitle {
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 22px;
      color: #3e1876;
    }

    &-description {
      margin-top: 16px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 26px;
      color: #3c4242;
    }
  }

  &__sources {
    margin-top: 64px;

    &-title {
      margin-bottom: 48px;
      font-family: "Roboto Slab", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 42px;
      line-height: 48px;
      text-align: center;
      color: #1f1f1f;
      @media screen and (max-width: 767px) {
        font-size: 26px;
        text-align: left;
        margin-bottom: 24px;
      }
    }

    &-list {
      list-style-type: decimal;
      margin-left: 1em;
      & li {
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 26px;
        color: #3c4242;
        @media screen and (max-width: 767px) {
          font-size: 12px;
          line-height: 16px;
        }

        & a {
          text-decoration: underline;
          overflow-wrap: break-word;
        }

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }
  }
}
</style>